import { cn } from "@/lib/utils";

interface Lender {
  name: string;
  logo: string;
}

interface LenderLogosProps {
  lenders?: Lender[];
  className?: string;
  variant?: "default" | "grayscale";
}

/**
 * Lender logo cloud component
 * Based on lender-panel inspiration
 */
export function LenderLogos({
  lenders = defaultLenders,
  className,
  variant = "default",
}: LenderLogosProps) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-center gap-8 md:gap-12",
        className
      )}
    >
      {lenders.map((lender) => (
        <div
          key={lender.name}
          className={cn(
            "h-8 md:h-10 flex items-center",
            variant === "grayscale" && "grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all"
          )}
        >
          <img
            src={lender.logo}
            alt={`${lender.name} logo`}
            className="h-full w-auto object-contain"
          />
        </div>
      ))}
    </div>
  );
}

/**
 * Default lender logos - major Australian banks
 */
export const defaultLenders: Lender[] = [
  { name: "Commonwealth Bank", logo: "/lenders/commbank.png" },
  { name: "Westpac", logo: "/lenders/westpac.png" },
  { name: "NAB", logo: "/lenders/nab.png" },
  { name: "Macquarie", logo: "/lenders/macquarie.png" },
  { name: "St.George", logo: "/lenders/st-george.webp" },
  { name: "ING", logo: "/lenders/ing.png" },
  { name: "Bankwest", logo: "/lenders/bankwest.png" },
  { name: "Suncorp", logo: "/lenders/suncorp.png" },
];

/**
 * Text-based placeholder when logos aren't available
 */
export function LenderLogosPlaceholder({ className }: { className?: string }) {
  const lenderNames = [
    "Commonwealth Bank",
    "ANZ",
    "Westpac",
    "NAB",
    "Macquarie",
    "St.George",
    "ING",
    "Bankwest",
  ];

  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-center gap-6 md:gap-8",
        className
      )}
    >
      {lenderNames.map((name) => (
        <span
          key={name}
          className="text-sm font-medium text-muted-foreground px-4 py-2 bg-muted rounded-lg"
        >
          {name}
        </span>
      ))}
    </div>
  );
}
